import { render, staticRenderFns } from "./member_agreement_new.vue?vue&type=template&id=45d775a2&scoped=true"
import script from "./member_agreement_new.vue?vue&type=script&lang=js"
export * from "./member_agreement_new.vue?vue&type=script&lang=js"
import style0 from "./member_agreement_new.vue?vue&type=style&index=0&id=45d775a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d775a2",
  null
  
)

export default component.exports